<div id="hero-image" [ngStyle]="{ backgroundImage: 'url(./assets/images/bck-hero-image.png)' }">
  <a href="https://academy.board.com/demo-portal-tutorial" target="_blank" class="hero-title">
    <img src="assets/images/hero-title.svg" />
  </a>
</div>
